/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core'
import React from 'react'
import WithdrawRequestDetail from './DetailWithdraw'

const ShowDialog = ({ open, onClose, showId }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
  >
    <DialogTitle>
      Detail Permintaan Withdraw
    </DialogTitle>
    <DialogContent>
      <WithdrawRequestDetail showId={showId} />
    </DialogContent>
    <DialogActions>
      <Button
        variant="outlined"
        color="primary"
        onClick={onClose}
      >
        Tutup
      </Button>
    </DialogActions>
  </Dialog>
)

export default ShowDialog
